import * as React from "react";
import { Option } from "space-monad";
import styled from "styled-components";
import { Icon } from "../../../../../components/icons";
import {
  CenteredFlex,
  columnFlex,
  Flex,
} from "../../../../../components/layout";
import { colours } from "../../../../../styles/colours";
import { device, size } from "../../../../../styles/media";

const MainIcon = styled(Icon)`
  height: 8em;
  width: 8em;
  margin: 2em 0;
`;

interface IResultPageProps {
  error: Option<Error>;
}

const Wrapper = styled(Flex)`
  ${columnFlex};
  ${CenteredFlex};
  max-width: 100%;

  @media ${device.tablet} {
    width: 30em;
    height: 20em;
  }
`;

const Title = styled.h1`
  @media (max-width: ${size.tablet - 1}px) {
    margin-top: 0;
  }
`;

const ResultPage: React.FunctionComponent<IResultPageProps> = ({ error }) => {
  return (
    <Wrapper>
      {error.fold(
        () => (
          <>
            <Title>Success!</Title>
            <MainIcon type="veryGoodCheck" />
            <p>You have successfully claimed rewards</p>
          </>
        ),
        (err) => (
          <>
            <Title>Error</Title>
            <MainIcon type="close" colour1={colours.redFailed} />
            <p>{err.message}</p>
          </>
        )
      )}
    </Wrapper>
  );
};

export default ResultPage;
